import { SVGProps } from "react";

const LogoutIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 4.23639C3.5 3.37422 4.19893 2.67529 5.0611 2.67529H9.93954V3.84612H5.0611C4.84556 3.84612 4.67083 4.02085 4.67083 4.23639V19.8474C4.67083 20.0629 4.84556 20.2377 5.0611 20.2377H9.93954V21.4085H5.0611C4.19893 21.4085 3.5 20.7096 3.5 19.8474V4.23639ZM16.2076 6.74951L21.5 12.0419L16.2076 17.3343L15.3797 16.5064L19.2588 12.6273H7.98816V11.4565H19.2588L15.3797 7.5774L16.2076 6.74951Z"
        fill="black"
      />
    </svg>
  );
};

export default LogoutIcon;
